// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-tkk","content":"styles_content__gE-tI"};